/*
  NOTE: You may be able to get rid of this with 1.0. This is required by poor planning of creating the instanceId when defining a loadout.
   InstanceIds are needed for giving uniqueness to possible repeatable inventory items. Right now, we have a problem that all Class X's have the same instanceIds on their items.
   Thus the need to salt them. If you created the randomId when gathering a lineup, it would be fine. But baking the instanceId into the preset is not fine. and here we are...
*/


import makeId from '../../helpers/make-id.js'
export function addSaltedItemInstanceIdsToCombatants(combatants) {

  //Add a little salt at the end of an item's instanceID. If the item does not have an instanceId, provide one.
  let payload = {};
  Object.keys(combatants).forEach(key => {
    const model = combatants[key];

    const updatedItems = model.items.map(item => {

      const randomSalt = makeId("s", 10);

      return {
        ...item,
        instanceId: item.instanceId ? `${item.instanceId}+` + randomSalt : `${makeId("instance", 12)}+` + randomSalt
      }
    });

    payload[key] = {
      ...model,
      items: updatedItems
    }



  });

  return payload;

}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/addSaltedItemInstanceIdsToCombatants.js